import {selectMosaicByName} from '@explorer/actions/mosaics';
import {selectSeries, setActiveSeriesId} from '@explorer/actions/series';

export const buildMosaicsActions = storedState => {
  const actions = [];
  // keep backwards compat
  if (storedState.series?.selectedId || storedState.mosaics?.selectedSeriesId) {
    const seriesId =
      storedState.series?.selectedId || storedState.mosaics?.selectedSeriesId;
    actions.push(selectSeries(seriesId));
    actions.push(setActiveSeriesId(seriesId));
  }

  if (
    storedState.mosaics?.selectedName &&
    (storedState.series?.selectedId || storedState.mosaics?.selectedSeriesId)
  ) {
    // keep backwards compat
    actions.push(selectMosaicByName(storedState.mosaics?.selectedName));
    // ToDo: Lookup mosaic by name
  }

  return actions;
};
